import { useState, useEffect } from "react";
import { Avatar, VybePill, Ic, ICONS } from "../components/UI.jsx";
import api from "../api/client.js";

const B = {
  bg:"#08070F",bg2:"#0D0C18",bg3:"#131124",
  violet:"#7C3AED",violetLt:"#8B5CF6",
  violetDim:"rgba(124,58,237,0.15)",
  vibeGreen:"#10F5A0",vibeGreenDim:"rgba(16,245,160,0.12)",
  coral:"#FF6B6B",coralDim:"rgba(255,107,107,0.12)",
  amber:"#FFB830",sky:"#38BDF8",skyDim:"rgba(56,189,248,0.12)",
  purple:"#A78BFA",teal:"#2DD4BF",
  text:"#F0EFFE",text2:"#7C7A9E",text3:"#3D3B5C",
  border:"rgba(124,58,237,0.15)",border2:"rgba(124,58,237,0.08)",
  grad:"linear-gradient(135deg,#7C3AED,#10F5A0)",
  font:"'Sora',system-ui,sans-serif",mono:"'Space Mono',monospace",
};

const TOPICS = [
  { label:"⚡ Tech Vibes",       color:B.sky,       count:"4.2k members",  key:"Tech Vibes"       },
  { label:"🌍 Global Connect",   color:B.vibeGreen, count:"9.1k members",  key:"Global Connect"   },
  { label:"🎨 Creative Learn",   color:B.amber,     count:"3.8k members",  key:"Creative Learn"   },
  { label:"🧠 Human Potential",  color:B.purple,    count:"6.5k members",  key:"Human Potential"  },
  { label:"🌾 AgriTech",         color:B.teal,      count:"2.1k members",  key:"AgriTech"         },
  { label:"🏛️ DAO Governance",   color:B.coral,     count:"1.4k members",  key:"DAO Governance"   },
];

const TRENDING = [
  { cat:"Tech Vibes",   tag:"#DAOs",         count:"847 vibes"  },
  { cat:"Global",       tag:"#AgriTech10k",  count:"2.9k vibes" },
  { cat:"Creative",     tag:"#ClimateArt",   count:"1.3k vibes" },
  { cat:"Learning",     tag:"#SecondBrain",  count:"634 vibes"  },
  { cat:"DAO",          tag:"#OpenSource",   count:"512 vibes"  },
];

function ConnectBtn({ userId, small }) {
  const [connected, setConnected] = useState(false);
  const toggle = async (e) => {
    e.stopPropagation();
    setConnected(v => !v);
    try { await api.post(`/users/${userId}/follow`); } catch {}
  };
  return (
    <button onClick={toggle} style={{
      padding: small ? "5px 12px" : "7px 18px",
      borderRadius:9999, fontWeight:700, fontSize:small?12:13, cursor:"pointer",
      fontFamily:B.font, transition:"all 0.2s", flexShrink:0,
      background: connected ? "transparent" : B.grad,
      color: connected ? B.text : "#fff",
      border: connected ? `1px solid ${B.border}` : "none",
      boxShadow: connected ? "none" : "0 4px 14px rgba(124,58,237,0.35)",
    }}>{connected ? "Connected ✓" : "Connect"}</button>
  );
}

export default function ExplorePage({ onCall }) {
  const [q, setQ]           = useState("");
  const [results, setResults] = useState({ users:[], vibes:[], spaces:[] });
  const [searching, setSearching] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [activeTopic, setActiveTopic] = useState(null);

  useEffect(() => {
    api.get("/users/suggestions/connect").then(r => setSuggestions(r.data)).catch(()=>{});
  }, []);

  useEffect(() => {
    if (!q.trim()) { setResults({ users:[], vibes:[], spaces:[] }); return; }
    const t = setTimeout(async () => {
      setSearching(true);
      try {
        const { data } = await api.get(`/search?q=${encodeURIComponent(q)}`);
        setResults(data);
      } catch {}
      setSearching(false);
    }, 350);
    return () => clearTimeout(t);
  }, [q]);

  const hasResults = q.trim() && (results.users?.length || results.vibes?.length);

  return (
    <div style={{ display:"flex",flexDirection:"column",height:"100%",overflow:"hidden" }}>
      {/* Search bar */}
      <div style={{ padding:"12px 16px",borderBottom:`1px solid ${B.border2}`,flexShrink:0 }}>
        <div style={{ display:"flex",alignItems:"center",gap:10,background:B.bg3,borderRadius:12,padding:"11px 16px",border:`1px solid ${B.border2}`,transition:"border-color 0.2s" }}
          onFocus={() => {}} >
          <Ic d={ICONS.search} s={18} c={searching ? B.violetLt : B.text2} />
          <input
            value={q} onChange={e => setQ(e.target.value)}
            placeholder="Explore vibes, people, topics…"
            style={{ flex:1,background:"none",border:"none",color:B.text,fontFamily:B.font,fontSize:15,outline:"none" }}
            autoFocus
          />
          {searching && <div className="vyl-spinner" />}
          {q && (
            <button onClick={() => setQ("")} style={{ background:"none",border:"none",cursor:"pointer",color:B.text2,padding:2 }}>
              <Ic d={ICONS.close} s={16} c={B.text2} />
            </button>
          )}
        </div>
      </div>

      <div style={{ flex:1,overflowY:"auto" }}>
        {hasResults ? (
          /* ── Search results ── */
          <div>
            {results.users?.length > 0 && (
              <>
                <div style={{ padding:"12px 16px 6px",fontSize:11,fontWeight:700,color:B.text2,letterSpacing:1.5,fontFamily:B.mono }}>PEOPLE</div>
                {results.users.map((u,i) => (
                  <div key={i} style={{ display:"flex",alignItems:"center",gap:12,padding:"12px 16px",borderBottom:`1px solid ${B.border2}`,cursor:"pointer" }}
                    onMouseEnter={e=>e.currentTarget.style.background=B.violetDim}
                    onMouseLeave={e=>e.currentTarget.style.background="none"}>
                    <Avatar user={u} size={44} showOnline />
                    <div style={{ flex:1 }}>
                      <div style={{ display:"flex",alignItems:"center",gap:5 }}>
                        <span style={{ fontWeight:700,fontSize:15,color:B.text }}>{u.displayName}</span>
                        {u.verified && <span style={{ color:B.violet,fontSize:13 }}>✓</span>}
                      </div>
                      <div style={{ fontSize:13,color:B.text2 }}>{u.handle} · {u.role}</div>
                    </div>
                    <div style={{ display:"flex",gap:6 }}>
                      <button onClick={()=>onCall?.({type:"voice",user:u})} style={{ width:30,height:30,borderRadius:"50%",border:"none",background:`rgba(16,245,160,0.12)`,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center" }}>
                        <Ic d={ICONS.phone} s={13} c={B.vibeGreen} />
                      </button>
                      <ConnectBtn userId={u._id} small />
                    </div>
                  </div>
                ))}
              </>
            )}
            {results.vibes?.length > 0 && (
              <>
                <div style={{ padding:"12px 16px 6px",fontSize:11,fontWeight:700,color:B.text2,letterSpacing:1.5,fontFamily:B.mono }}>VIBES</div>
                {results.vibes.map((v,i) => (
                  <div key={i} style={{ display:"flex",gap:12,padding:"12px 16px",borderBottom:`1px solid ${B.border2}`,cursor:"pointer" }}
                    onMouseEnter={e=>e.currentTarget.style.background=B.violetDim}
                    onMouseLeave={e=>e.currentTarget.style.background="none"}>
                    <Avatar user={v.author} size={36} />
                    <div style={{ flex:1 }}>
                      <div style={{ fontWeight:700,fontSize:14,color:B.text }}>{v.author?.displayName}</div>
                      <div style={{ fontSize:14,color:B.text2,marginTop:2,lineHeight:1.5 }}>{v.content?.slice(0,120)}{v.content?.length>120?"…":""}</div>
                    </div>
                  </div>
                ))}
              </>
            )}
            {!results.users?.length && !results.vibes?.length && (
              <div style={{ padding:48,textAlign:"center" }}>
                <div style={{ fontSize:40,marginBottom:12 }}>🔍</div>
                <div style={{ fontWeight:700,fontSize:18,color:B.text,marginBottom:6 }}>No results for "{q}"</div>
                <div style={{ color:B.text2 }}>Try different keywords or explore topics below</div>
              </div>
            )}
          </div>
        ) : (
          /* ── Discovery view ── */
          <>
            {/* Topics grid */}
            <div style={{ padding:"14px 16px 8px",fontSize:11,fontWeight:700,color:B.text2,letterSpacing:1.5,fontFamily:B.mono }}>VYLAPP TOPICS</div>
            <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,padding:"0 16px 16px" }}>
              {TOPICS.map((t,i) => (
                <button key={i} onClick={() => setActiveTopic(activeTopic===t.key?null:t.key)} style={{
                  padding:16,background:activeTopic===t.key?`${t.color}15`:B.bg3,
                  borderRadius:14,cursor:"pointer",textAlign:"left",
                  border:`1px solid ${activeTopic===t.key?t.color+"40":B.border2}`,
                  transition:"all 0.2s", boxShadow:activeTopic===t.key?`0 0 20px ${t.color}15`:"none",
                }}>
                  <div style={{ fontWeight:700,fontSize:14,color:B.text,marginBottom:4 }}>{t.label}</div>
                  <div style={{ fontSize:12,color:t.color,fontFamily:B.mono }}>{t.count}</div>
                  {activeTopic===t.key && (
                    <div style={{ marginTop:8,display:"flex",gap:6 }}>
                      <span style={{ fontSize:10,color:t.color,fontFamily:B.mono }}>✓ JOINED</span>
                    </div>
                  )}
                </button>
              ))}
            </div>

            {/* Trending */}
            <div style={{ padding:"0 16px 8px",fontSize:11,fontWeight:700,color:B.text2,letterSpacing:1.5,fontFamily:B.mono }}>TRENDING NOW</div>
            {TRENDING.map((t,i) => (
              <div key={i} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"13px 16px",borderBottom:`1px solid ${B.border2}`,cursor:"pointer" }}
                onMouseEnter={e=>e.currentTarget.style.background=B.violetDim}
                onMouseLeave={e=>e.currentTarget.style.background="none"}>
                <div>
                  <div style={{ fontSize:12,color:B.text2,marginBottom:2 }}>{t.cat} · Trending</div>
                  <div style={{ fontWeight:700,fontSize:15,color:B.text,marginBottom:1 }}>{t.tag}</div>
                  <div style={{ fontSize:12,color:B.text2,fontFamily:B.mono }}>{t.count}</div>
                </div>
                <div style={{ display:"flex",alignItems:"center",gap:8 }}>
                  <span style={{ fontSize:12,color:B.text3 }}>#{i+1}</span>
                  <Ic d={ICONS.trending} s={18} c={B.violetLt} />
                </div>
              </div>
            ))}

            {/* Who to connect */}
            {suggestions.length > 0 && (
              <>
                <div style={{ padding:"14px 16px 6px",fontSize:11,fontWeight:700,color:B.text2,letterSpacing:1.5,fontFamily:B.mono,marginTop:4 }}>VIBERS TO CONNECT</div>
                {suggestions.map((u,i) => (
                  <div key={i} style={{ display:"flex",alignItems:"center",gap:12,padding:"12px 16px",borderBottom:`1px solid ${B.border2}`,cursor:"pointer" }}
                    onMouseEnter={e=>e.currentTarget.style.background=B.violetDim}
                    onMouseLeave={e=>e.currentTarget.style.background="none"}>
                    <Avatar user={u} size={44} showOnline />
                    <div style={{ flex:1 }}>
                      <div style={{ display:"flex",alignItems:"center",gap:5 }}>
                        <span style={{ fontWeight:700,fontSize:15,color:B.text }}>{u.displayName}</span>
                        {u.verified && <span style={{ color:B.violet,fontSize:13 }}>✓</span>}
                      </div>
                      <div style={{ fontSize:13,color:B.text2 }}>{u.handle} · {u.role}</div>
                    </div>
                    <ConnectBtn userId={u._id} />
                  </div>
                ))}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
